import type { IconSvgObject } from './types';

const FireSecurityIcon: IconSvgObject = [
  ["path", { d: "M15.5 16.5H14V22H21V16.5H19.5M15.5 16.5V15C15.5 13.8954 16.3954 13 17.5 13C18.6046 13 19.5 13.8954 19.5 15V16.5M15.5 16.5H19.5", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10.945 22C6.55711 22 3 18.4183 3 14C3 11.9162 3.95829 9.83244 5.20924 8C5.46596 9.5 6.57526 12.4 8.95878 12C6.33498 6.5 10.945 2 10.945 2C10.945 2 11.4416 5.5 15.9107 9C16.3245 9.32407 16.6857 9.65805 17 10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default FireSecurityIcon;
